<ion-header mode="ios">
  <ion-toolbar mode="ios">
    <ion-buttons slot="start">
      <app-modal-back-button
        iconSrc="/assets/icon/back-icon-dark.svg"
        [priority]="9998"
      (activated)="onDismiss()"></app-modal-back-button>
    </ion-buttons>
    <ion-title>{{ title }}</ion-title>
  </ion-toolbar>
  @if (banner) {
    <div class="banner-container">
      <div class="wording">{{ banner }}</div>
    </div>
  }
</ion-header>
<ion-content>
  @for (summaryItem of summaryItems; track summaryItem; let i = $index) {
    <div class="question-container">
      <div class="header">
        <div class="slide-number">{{ i + 1 }}</div>
        <div class="flexibility" [ngClass]="summaryItem.flexibility">{{ summaryItem.flexibility }}</div>
      </div>
      <div class="question">{{ summaryItem.question }}</div>
      <ng-container>
        @if (summaryItem.renderAs === 'text') {
          <div class="text-value" [ngClass]="{ redacted: redacted }">
            {{ summaryItem.textValue }}
          </div>
        }
        @if (summaryItem.renderAs === 'list') {
          <div class="multi-select">
            @for (listItem of summaryItem.listValue.items; track listItem) {
              <div
                class="option"
                [ngClass]="listItem.selected ? 'selected' : ''">
                <span>{{ listItem.legend }}</span>
              </div>
            }
          </div>
        }
      </ng-container>
    </div>
  }
</ion-content>
